export const regularExpressions = {
  name: new RegExp('^(\\s)*[a-zA-ZÀ-ž]{1,}([\\-|\\\'|\\‘][a-zA-ZÀ-ž]{1,}){0,1}(\\s[a-zA-ZÀ-ž]{1,}([\\-|\\\'|\\‘][a-zA-ZÀ-ž]{1,}){0,1}){0,}(\\s)*$'),
}
